/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Аутентификация
 * Аутентификация
 * OpenAPI spec version: 1.0.0
 */
import { instance } from '../instance';
import type { GetGroupUsers200, GetUserInfo200 } from '../schemas';

/**
 * Получить информацию о пользователе по идентификатору
 * @summary Информация о пользователе
 */
export type getUserInfoResponse200 = {
  data: GetUserInfo200;
  status: 200;
};

export type getUserInfoResponseSuccess = getUserInfoResponse200 & {
  headers: Headers;
};
export const getGetUserInfoUrl = (id: string) => {
  return `/api/v1/user/${id}`;
};

export const getUserInfo = async (
  id: string,
  options?: RequestInit,
): Promise<getUserInfoResponseSuccess> => {
  return instance<getUserInfoResponseSuccess>(getGetUserInfoUrl(id), {
    ...options,
    method: 'GET',
  });
};

/**
 * Получить список пользователей по идентификатору группы
 * @summary Список пользователей группы
 */
export type getGroupUsersResponse200 = {
  data: GetGroupUsers200;
  status: 200;
};

export type getGroupUsersResponseSuccess = getGroupUsersResponse200 & {
  headers: Headers;
};
export const getGetGroupUsersUrl = (id: string) => {
  return `/api/v1/groups/${id}/users`;
};

export const getGroupUsers = async (
  id: string,
  options?: RequestInit,
): Promise<getGroupUsersResponseSuccess> => {
  return instance<getGroupUsersResponseSuccess>(getGetGroupUsersUrl(id), {
    ...options,
    method: 'GET',
  });
};
